<template>
  <Modal :hide-close="true" class="max-w-[500px]! px-0!">
    <div class="px-6">
      <StepModalHeader
        :title="checker.title.value"
        :back="checker.step.value !== 'capture'"
        :centered="checker.step.value !== 'details'"
        :busy="checker.creating.value !== null"
        @back="checker.back"
        @close="close()"
      />
    </div>

    <CheckerBody variant="modal" />
  </Modal>
</template>

<script setup lang="ts">
import { Modal, useModal } from '@dacr/library'

import StepModalHeader from '../match/StepModalHeader.vue'
import CheckerBody from './CheckerBody.vue'
import { provideChecker } from './useChecker'

const { close } = useModal()
const checker = provideChecker()
</script>
